import React from 'react';
import { Button, Card, Input, Pagination, Spin, Typography } from 'antd';
import type { AdminProductsCardProps } from '../../interfaces';
import AdminProductsList from '../AdminProductsList';
import './AdminProductsCard.scss';

const { Title, Text } = Typography;

const AdminProductsCard: React.FC<AdminProductsCardProps> = (props) => (
  <Card className="admin-product-form__card">
    <div className="admin-product-form__products-topbar">
      <div>
        <Title level={4}>Existing Products</Title>
        <Text type="secondary">Update stock by material or remove a product completely.</Text>
      </div>
      <div className="admin-product-form__products-search">
        <Input
          placeholder="Search products"
          value={props.searchTerm}
          onChange={(event) => props.onSearchTermChange(event.target.value)}
          onPressEnter={() => void props.onSearch()}
          allowClear
        />
        <Button
          onClick={() => void props.onSearch()}
          loading={props.searchingProducts}
          disabled={props.loadingProducts}
        >
          Search
        </Button>
        {props.activeSearchTerm && (
          <Button onClick={() => void props.onClearSearch()} disabled={props.searchingProducts || props.loadingProducts}>
            Clear
          </Button>
        )}
      </div>
    </div>
    <div className="admin-product-form__products-status">
      <Text type="secondary">
        {props.activeSearchTerm
          ? `Showing ${props.products.length} of ${props.productsTotal} product${props.productsTotal === 1 ? '' : 's'} matching "${props.activeSearchTerm}".`
          : `Showing ${props.products.length} of ${props.productsTotal} product${props.productsTotal === 1 ? '' : 's'}.`}
      </Text>
      <Text type="secondary">Search queries the full product database.</Text>
    </div>
    {props.loadingProducts ? (
      <div className="admin-product-form__loader"><Spin /></div>
    ) : (
      <AdminProductsList
        products={props.products}
        deletingProductId={props.deletingProductId}
        savingStockId={props.savingStockId}
        savingPriceId={props.savingPriceId}
        savingSizesId={props.savingSizesId}
        loadingMaterialDetailsById={props.loadingMaterialDetailsById}
        draftStockById={props.draftStockById}
        draftPriceById={props.draftPriceById}
        sizes={props.sizes}
        onDeleteProduct={props.onDeleteProduct}
        onStockStep={props.onStockStep}
        onDraftStockInput={props.onDraftStockInput}
        onDraftPriceInput={props.onDraftPriceInput}
        onCommitDraftStock={props.onCommitDraftStock}
        onCommitDraftPrice={props.onCommitDraftPrice}
        onCommitMaterialSizes={props.onCommitMaterialSizes}
        onLoadMaterialDetails={props.onLoadMaterialDetails}
        onAvailabilityChange={props.onAvailabilityChange}
        onVariantAvailabilityChange={props.onVariantAvailabilityChange}
        onUploadMaterialImages={props.onUploadMaterialImages}
        onDeleteMaterialImage={props.onDeleteMaterialImage}
      />
    )}
    {!props.loadingProducts && props.productsTotal > props.productsPageSize && (
      <div className="admin-product-form__pagination">
        <Pagination
          current={props.currentPage}
          pageSize={props.productsPageSize}
          total={props.productsTotal}
          showSizeChanger={false}
          onChange={props.onPageChange}
          disabled={props.searchingProducts || props.loadingMoreProducts}
        />
      </div>
    )}
  </Card>
);

export default AdminProductsCard;
